import { Outlet } from 'react-router-dom';

import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';

import { AUTH_SUB_PAGES } from 'src/pages/auth/auth.constants';
import {
  ForgotPassword,
  ResetPassword,
  SignUp,
  Validation,
  Verification,
} from 'src/pages/auth/sub-pages';
import { WelcomePage } from 'src/pages/auth/sub-pages/welcome';
import Dashboard from 'src/pages/dashboard/dashboard.page';
import NotFound from 'src/pages/not-found/not-found.page';
import Notifications from 'src/pages/notifications/notifications.page';
// import OrgStructure from 'src/pages/org-structure/org-structure.page';
import { EMPLOYEE_PAGES } from 'src/pages/employee/employee.constants';
import Employee from 'src/pages/employee/employee.page';
import { CreateEmployee } from 'src/pages/employee/sub-pages/create-employee';
import { EmployeeDetailsLimitedView } from 'src/pages/employee/sub-pages/employee-details-limited-view';
import { CreateJob } from 'src/pages/jobs/components/create-job';
import { JobDetailsPage } from 'src/pages/jobs/components/job-details-page';
import { JOBS_PAGES } from 'src/pages/jobs/jobs.constants';
import Jobs from 'src/pages/jobs/jobs.page';
import { AddSubsidiaryCompany } from 'src/pages/settings/components/company-profile/components/add-subsidiary-company';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';
import Settings from 'src/pages/settings/settings.page';
import UserProfile from 'src/pages/user-profile/user-profile.page';
import { CreateVacancyPage } from 'src/pages/vacancies/sub-pages/create-vacancy-page';
import { VacancyDetails } from 'src/pages/vacancies/sub-pages/vacancy-details';
import { VACANCIES_PAGES } from 'src/pages/vacancies/vacancies.constants';
import Vacancies from 'src/pages/vacancies/vacancies.page';
import { ApplicantRequestPage } from 'src/components/applicant-request-page';
import { CreateEmployeeBYQuestionnaire } from 'src/pages/employee/sub-pages/create-employee-by-questionnaire';
import QuestionnairePage from 'src/pages/auth/sub-pages/questionnaire';
import { AcceptQuestionnaire } from 'src/pages/employee/sub-pages/accept-questionnaire';
import QuestionnairePreviewComponent from 'src/pages/settings/components/employee-questionnaire-settings/components/questionnaire-preview/questionnaire-preview.component';
import PayrollAccountingPage from 'src/pages/payroll-accounting/payroll-accounting.page';
import TaskManager from 'src/pages/tasks-manager/task-manager.page';
import DocumentImporter from 'src/pages/document-importer/document-importer.page';
import OwnData from 'src/pages/own-data/own-data.page';
import Applications from '../../pages/applications/applications.page';

export const ROUTES = {
  dashboard: '/',
  auth: '/auth',
  orgStructure: '/org-structure',
  employee: '/employee',
  settings: '/settings',
  jobs: '/jobs',
  vacancies: '/vacancies',
  taskManager: '/task-manager',
  notifications: '/notifications',
  application: '/application',
  userProfile: '/user-profile',
  health: '/health',
  payrollAccounting: '/payroll-accounting',
  documentImporter: '/document-Importer',
  ownData: '/own-data',
  notFound: '*',
};

export const SUB_ROUTES = {
  authVerification: `${ROUTES.auth}/${AUTH_SUB_PAGES.verification}`,
  authValidation: `${ROUTES.auth}/${AUTH_SUB_PAGES.validation}`,
  authForgotPassword: `${ROUTES.auth}/${AUTH_SUB_PAGES.forgotPassword}`,
  authWelcome: `${ROUTES.auth}/${AUTH_SUB_PAGES.welcome}`,
};

export const ROUTES_RELATIONS = [
  {
    path: ROUTES.auth,
    PageComponent: Outlet,
    isProtected: false,
    children: [
      {
        subpath: AUTH_SUB_PAGES.verification,
        SubPageComponent: Verification,
      },
      {
        subpath: AUTH_SUB_PAGES.validation,
        SubPageComponent: Validation,
      },
      {
        subpath: AUTH_SUB_PAGES.forgotPassword,
        SubPageComponent: ForgotPassword,
      },
      {
        subpath: AUTH_SUB_PAGES.resetPassword,
        SubPageComponent: ResetPassword,
      },
      {
        subpath: AUTH_SUB_PAGES.signUp,
        SubPageComponent: SignUp,
      },
      {
        subpath: AUTH_SUB_PAGES.welcome,
        SubPageComponent: WelcomePage,
      },
      {
        subpath: AUTH_SUB_PAGES.questionnaire,
        SubPageComponent: QuestionnairePage,
        withoutSidebar: true
      },
    ],
  },
  {
    path: ROUTES.dashboard,
    PageComponent: Dashboard,
  },
  // {
  //   path: ROUTES.orgStructure,
  //   PageComponent: OrgStructure,
  // },
  {
    path: ROUTES.employee,
    PageComponent: Employee,
  },
  {
    path: ROUTES.application,
    PageComponent: Applications,
  },
  {
    path: `${ROUTES.employee}/${EMPLOYEE_PAGES.createEmployee}`,
    PageComponent: CreateEmployee,
    permission: PLATFORM_PERMISSIONS.memberManagement,
  },
  {
    path: `${ROUTES.employee}/${EMPLOYEE_PAGES.createEmployeeByQuestionnaire}`,
    PageComponent: CreateEmployeeBYQuestionnaire,
    permission: PLATFORM_PERMISSIONS.memberManagement,
  },
  {
    path: `${ROUTES.employee}/${EMPLOYEE_PAGES.acceptQuestionnaire}`,
    PageComponent: AcceptQuestionnaire,
    permission: PLATFORM_PERMISSIONS.memberManagement,
  },
  {
    path: `${ROUTES.employee}/${EMPLOYEE_PAGES.employeeDetails}:id`,
    PageComponent: EmployeeDetailsLimitedView,
  },
  {
    path: ROUTES.jobs,
    PageComponent: Jobs,
    permission: PLATFORM_PERMISSIONS.jobManagement,
  },
  {
    path: `${ROUTES.jobs}/${JOBS_PAGES.createJob}`,
    PageComponent: CreateJob,
    permission: PLATFORM_PERMISSIONS.jobManagement,
  },
  {
    path: `${ROUTES.jobs}/${JOBS_PAGES.jobDetailsPage}`,
    PageComponent: JobDetailsPage,
    permission: PLATFORM_PERMISSIONS.jobManagement,
  },
  {
    path: ROUTES.vacancies,
    PageComponent: Vacancies,
    permission: PLATFORM_PERMISSIONS.vacanciesManagement,
  },
  {
    path: `${ROUTES.vacancies}/${VACANCIES_PAGES.createVacancy}`,
    PageComponent: CreateVacancyPage,
    permission: PLATFORM_PERMISSIONS.vacanciesManagement,
  },
  {
    path: `${ROUTES.vacancies}/${VACANCIES_PAGES.vacancyDetails}:id`,
    PageComponent: VacancyDetails,
    permission: PLATFORM_PERMISSIONS.vacanciesManagement,
  },
  {
    path: `${ROUTES.vacancies}/${VACANCIES_PAGES.applicantRequestForm}:id`,
    PageComponent: ApplicantRequestPage,
    isProtected: false,
  },
  {
    path: ROUTES.taskManager,
    PageComponent: TaskManager,
    permission: PLATFORM_PERMISSIONS.taskManagement,
  },
  {
    path: `${ROUTES.payrollAccounting}`,
    PageComponent: PayrollAccountingPage,
  },
  {
    path: `${ROUTES.documentImporter}`,
    PageComponent: DocumentImporter,
  },
  {
    path: ROUTES.ownData,
    PageComponent: OwnData,
  },
  {
    path: ROUTES.settings,
    PageComponent: Settings,
  },
  {
    path: `${ROUTES.settings}/${SETTINGS_PAGES.questionnairePreview}`,
    PageComponent: QuestionnairePreviewComponent,
  },
  {
    path: `${ROUTES.settings}/${SETTINGS_PAGES.addSubsidiaryCompany}`,
    PageComponent: AddSubsidiaryCompany,
  },
  {
    path: ROUTES.notifications,
    PageComponent: Notifications,
  },
  {
    path: ROUTES.userProfile,
    PageComponent: UserProfile,
  },
  {
    path: ROUTES.health,
    PageComponent: () => <>The App is Healthy</>,
    isProtected: false,
  },
  {
    path: ROUTES.notFound,
    PageComponent: NotFound,
    isProtected: false,
  },
];
